import { render, staticRenderFns } from "./LandingMenu.vue?vue&type=template&id=15f464aa&scoped=true&"
import script from "./LandingMenu.vue?vue&type=script&lang=js&"
export * from "./LandingMenu.vue?vue&type=script&lang=js&"
import style0 from "./LandingMenu.vue?vue&type=style&index=0&id=15f464aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f464aa",
  null
  
)

export default component.exports